import React, { Component } from 'react';
import Dropdown from './Dropdown';
import Checkbox from './Checkbox';

import {personsOptions} from '../config/options';
import {reasonOptions} from '../config/options'; 

class Filter extends Component {

    constructor(){
        super();
        this.handlePersonsSelection = this.handlePersonsSelection.bind(this);
        this.handleReasonSelection = this.handleReasonSelection.bind(this);
        this.handleBreakfastSelection = this.handleBreakfastSelection.bind(this);
        this.handleDoublebedSelection = this.handleDoublebedSelection.bind(this);
        this.handleKitchenSelection = this.handleKitchenSelection.bind(this);
        this.handlePlaceforkidsSelection = this.handlePlaceforkidsSelection.bind(this);
        this.handlePetsallowedSelection = this.handlePetsallowedSelection.bind(this);
    }

    handlePersonsSelection(persons){
        this.props.onSelectPersons(persons);
    }

    handleReasonSelection(reason){
        this.props.onSelectReason(reason);
    }

    handleBreakfastSelection(event){
        this.props.onCheckBreakfast(event.target.checked);
    }

    handleDoublebedSelection(event){
        this.props.onCheckDoublebed(event.target.checked);
    }

    handleKitchenSelection(event){
        this.props.onCheckKitchen(event.target.checked);
    }

    handlePlaceforkidsSelection(event){
        this.props.onCheckPlaceforkids(event.target.checked);
    }

    handlePetsallowedSelection(event){
        this.props.onCheckPetsallowed(event.target.checked);
    }

    render(){
        if(this.props.visible){
            return(
                <div id="filter">
                    <h2>Filter</h2>
                    <div className="vb-filter">
                        <div className="vb-persons-box">
                            <label>Persons</label>
                            <Dropdown
                                    value={this.props.selectedPersons}
                                    options={personsOptions}
                                    onChange={this.handlePersonsSelection}
                                    placeholder={this.props.selectedPersons ? this.props.selectedPersons : 1}
                                    className='vb-select-rooms'
                                    name="persons"
                            />
                            <div className="vb-checkbox-box">

                                <div className="vb-checkbox">
                                    <Checkbox value="1" checked={this.props.breakfast} onChange={this.handleBreakfastSelection}/>                                    
                                    <p>Breakfast included</p>
                                </div>

                                <div className="vb-checkbox">
                                    <Checkbox value="1" checked={this.props.doublebed} onChange={this.handleDoublebedSelection}/>
                                    <p>One double bed</p>
                                </div>

                                <div className="vb-checkbox">
                                    <Checkbox value="1" checked={this.props.kitchen} onChange={this.handleKitchenSelection}/>
                                    <p>With kitchen</p>
                                </div>

                            </div>
                        </div>
                        <div className="vb-trip-reason-box">
                            <label>Trip reason</label>
                            <Dropdown
                                    value={this.props.selectedReason}
                                    options={reasonOptions}
                                    onChange={this.handleReasonSelection}
                                    placeholder='choose'
                                    className='vb-select-rooms'
                                    name="reason"
                            />
                            <div className="vb-checkbox-box">

                                <div className="vb-checkbox">
                                    <Checkbox value="1" checked={this.props.placeforkids} onChange={this.handlePlaceforkidsSelection}/>
                                    <p>Place for kids</p>
                                </div>

                                <div className="vb-checkbox">
                                    <Checkbox value="1" checked={this.props.petsallowed} onChange={this.handlePetsallowedSelection}/>
                                    <p>With pets</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            )
        }else{
            return false;
        }        
    }
}

export default Filter;